'use client';

import {
  HomeLandingSections,
  HomeStoriesSection,
  HomeCommunitySection,
  HomeVoicesSection,
  HomeAboutSection,
  CommunityMatrimonyServices,
} from '@/components/homePageSections';

import { useState } from 'react';
import Header from '@/components/Header';
import HomeHeroSection from '@/components/HomeHeroSection';

const faqItems = [
  { question: 'How to search the Maratha Groom in USA?', answer: 'To search USA based NRI Marathi grooms, visit MarathiVadhuVarSuchak.com for free registration.' },
  { question: 'How to search the CKP grooms USA?', answer: 'To search USA based NRI Marathi CKP grooms, download Marathi Vadhu Var Suchak app for free registration.' },
  { question: 'How to search CKP grooms Australia?', answer: 'Download Marathi Vadhu Var Suchak mobile app to search CKP grooms settled in Australia.' },
  { question: 'How to search CKP grooms Canada?', answer: 'To search CKP grooms settled in Canada, download Marathi Vadhu Var Suchak mobile app for free signup.' },
  { question: 'Which is the best Marathi CKP Matrimony USA?', answer: 'Marathi Vadhu Var Suchak mobile app is the best Marathi CKP Matrimony to search NRI Marathi Grooms in USA.' },
  { question: 'How to search verified Marathi Grooms in USA?', answer: 'To search verified Marathi Grooms in USA, download Marathi Vadhu Var Suchak mobile app for free registration.' },
  { question: 'How to search NRI Matrimony Grooms of Marathi community?', answer: 'To search NRI Marathi grooms, visit MarathiVadhuVarSuchak.com for free signup.' },
  { question: 'How to search NRI matrimony Photos with profile of Marathi grooms?', answer: 'You can search NRI Marathi grooms profile with photo on MarathiVadhuVarSuchak.com site.' },
  { question: 'How to search NRI Matrimony Girl of Marathi community?', answer: 'You can search Marathi NRI brides on Marathi Vadhu Var Suchak mobile app.' },
  { question: 'How to search Marathi NRI Matrimony Mumbai?', answer: 'To search Mumbai based NRI Marathi Matrimony, visit trusted MarathiVadhuVarSuchak.com site.' },
  { question: 'Which is the best Marathi NRI Matrimony Europe?', answer: 'To search verified NRI Marathi grooms and brides, register free through Marathi Vadhu Var Suchak mobile app.' },
  { question: 'Which are the best Free NRI matrimonial Sites for Marathi grooms?', answer: "From multiple options, 'Marathi Vadhu Var Suchak' is the best free NRI matrimonial Site to search Marathi grooms and brides." },
  { question: 'Which is the best NRI Marathi Matrimony in Mumbai?', answer: 'MarathiVadhuVarSuchak.com is the best NRI Marathi Matrimony in Mumbai for free signup.' },
  { question: 'How to search verified NRI Marathi grooms online?', answer: 'To search verified NRI Marathi grooms profiles, download Marathi Vadhu Var Suchak app.' },
  { question: 'Which is the trusted NRI matrimony USA for Marathi grooms?', answer: 'Download Marathi Vadhu Var Suchak app, which is the trusted NRI matrimony app to search USA based Marathi grooms and brides.' },
  { question: 'Which is the best NRI matrimony Australia for Marathi grooms?', answer: 'Download Marathi Vadhu Var Suchak mobile app, to search Australia based Marathi grooms and brides.' },
  { question: 'Which is the best USA NRI Matrimony for Marathi community?', answer: 'To search verified Marathi Grooms in USA, register free through MarathiVadhuVarSuchak.com portal.' },
  { question: 'Which is the best NRI Matrimony India to search Marathi grooms?', answer: 'To search NRI Marathi Grooms profile, download Marathi Vadhu Var Suchak app for free signup.' },
  { question: 'How to search Marathi NRI Matrimony Canada based Marathi grooms?', answer: 'To search Canada based NRI Marathi grooms profile, register through Marathi Vadhu Var Suchak app.' },
  { question: 'Which is the trusted Indian NRI Matrimony to search NRI Marathi grooms?', answer: 'MarathiVadhuVarSuchak.com is the most trusted Indian NRI Matrimony to search NRI Marathi grooms and brides profile.' },
  { question: 'How to search NRI Matrimony UK based Marathi grooms?', answer: 'To search NRI Marathi UK based grooms and brides profile, download Marathi Vadhu Var Suchak app.' },
  { question: 'Which are the best NRI matrimony services in India for Marathi community?', answer: 'From multiple options, Marathi Vadhu Var Suchak app is most trusted to search NRI Marathi grooms and brides.' },
  { question: 'Which is the best NRI Matrimony Portal for Marathi grooms and brides?', answer: 'Marathi Vadhu Var Suchak site is the best NRI Matrimony Portal for Marathi grooms and brides.' },
  { question: 'Which is the Free NRI matrimony to search Marathi grooms?', answer: 'Marathi Vadhu Var Suchak app is Free NRI matrimony to search Marathi grooms online.' },
  { question: 'How to search NRI matrimony Singapore based Marathi grooms?', answer: 'To search Singapore based NRI Marathi grooms, download and register free through Marathi Vadhu Var Suchak app.' },
];

const communityServices: { label: string; href?: string }[] = [
  { label: "Maratha Groom in USA" },
  { label: "CKP grooms USA" },
  { label: "CKP grooms Australia" },
  { label: "CKP grooms Canada" },
  { label: "CKP Matrimony USA" },
  { label: "Marathi Grooms in USA" },
  { label: "NRI Matrimony Grooms" },
  { label: "NRI matrimony Photos" },
  { label: "NRI matrimony girl" },
  { label: "NRI matrimony Mumbai" },
  { label: "NRI Matrimony Europe" },
  { label: "Free NRI matrimonial Sites" },
  { label: "NRI Marathi Matrimony" },
  { label: "NRI Marathi grooms" },
  { label: "NRI matrimony USA" },
  { label: "NRI matrimony Australia" },
  { label: "NRI Matrimony Sites" },
  { label: "USA NRI Matrimony" },
  { label: "NRI matrimony India" },
  { label: "NRI matrimony Canada" },
  { label: "Indian NRI Matrimony" },
  { label: "NRI Matrimony UK" },
  { label: "Best NRI matrimony services in India" },
  { label: "NRI Matrimony Portal" },
  { label: "Free NRI matrimony" },
  { label: "NRI matrimony Singapore" },
];

export default function NriMarathiGroomsInUsaClient() {
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);

  return (
    <div className="bg-white">
      <Header variant="transparent" />

      <HomeHeroSection
        title="सुशिक्षित एनआरआय मराठी वधू-वरांसाठी"
        subtitle="महाराष्ट्रातील अग्रणी विवाहसंस्था"
        trackingSource="nri_marathi_grooms_in_usa"
      />

      <HomeLandingSections />

      <HomeStoriesSection />

      <HomeCommunitySection />

      <HomeVoicesSection />

      <HomeAboutSection />

      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">Frequently Asked Questions</h2>
          <div className="max-w-4xl mx-auto">
            <div className="space-y-4">
              {faqItems.map((faq, index) => (
                <div key={index} className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm">
                  <button
                    onClick={() => setOpenFAQ(openFAQ === index ? null : index)}
                    className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors"
                  >
                    <h3 className="text-lg font-semibold text-gray-900">{faq.question}</h3>
                    <svg className={`w-5 h-5 text-gray-500 transition-transform duration-300 ${openFAQ === index ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  <div className={`px-6 transition-all duration-300 ease-in-out ${openFAQ === index ? 'pb-4 max-h-96 opacity-100' : 'max-h-0 opacity-0 overflow-hidden'}`}>
                    <div className="text-gray-600 leading-relaxed py-3">
                      <p className="mb-3">{faq.answer}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <CommunityMatrimonyServices
        title="Marathi Vadhu Var Suchak for NRI Marathi Grooms & Brides"
        items={communityServices}
      />

    </div>
  );
}
